/* eslint-disable react/destructuring-assignment */
import { goBack } from "connected-react-router";
import { useAccount } from "hooks/useAccounts";
import { isEmpty } from "lodash";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import { actions as agendaActions } from "reducers/contactDestination";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { shape, string } from "prop-types";
import React, { useContext, useEffect } from "react";
import { actions as notificationActions } from "reducers/notification";
import * as config from "util/config";
import Loader from "pages/_components/Loader";
import { useListContacts } from "pages/frequentDestination/hooks/useListContacts";

const MepTransferSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const { fetchingAgenda } = useListContacts({ loadDetail: false });

    const {
        debitAccount = props.debitAccountId,
        beneficiary = props.beneficiary,
        creditCbu = props.creditCbu,
        transferKind = props.transferKind,
        amount = props.amount,
        reasonCode = props.reasonCode,
        reference = props.reference,
    } = data;

    const { fetching: fetchingDebitAccount, selectedAccount: _debitAccount, formatAccountBody, dispatch } = useAccount(
        "productId",
        debitAccount,
    );

    useEffect(() => {
        if (isEmpty(_debitAccount)) {
            return;
        }
        if (_debitAccount?.uniformBankCode === creditCbu) {
            dispatch(notificationActions.showNotification("transfers.same.account.error", "error", ["otherTransfers"]));
            dispatch(goBack());
        }
    }, [_debitAccount]);

    useEffect(() => {
        if (beneficiary) {
            const filter = beneficiary?.cbu;
            dispatch(agendaActions.loadListRequest(filter));
        }
    }, [beneficiary]);

    if (fetchingDebitAccount || fetchingAgenda) {
        return <Loader />;
    }

    return (
        <GridTable className="form-summary">
            <GridTable.Container columns={3} rows={5}>
                <GridTable.Data columnStart={1} rowStart={2}>
                    <CustomData
                        titleText="mep.debitAccount.label"
                        titleTextType="I18N"
                        valueText={formatAccountBody(_debitAccount)}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={2}>
                    <CustomData
                        titleText="mep.creditAccount.label"
                        titleTextType="I18N"
                        valueText={formatAccountBody({
                            accountNumber: beneficiary?.accountNumber,
                            accountType: beneficiary?.productType.split(" ")[0],
                            currency: beneficiary?.productType.split(" ")[1],
                        })}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={2}>
                    <CustomData
                        titleText="mep.holder.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`transfer.types.${transferKind}`}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={3}>
                    <CustomData
                        titleText="mep.creditAccountCbuNumber.label"
                        titleTextType="I18N"
                        valueText={creditCbu}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={3}>
                    <CustomData
                        titleText="mep.holder.cuit"
                        titleTextType="I18N"
                        valueText={`${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={3}>
                    <CustomData
                        titleText="mep.holder.coporate.name"
                        titleTextType="I18N"
                        valueText={beneficiary?.recipientName}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={4}>
                    <CustomData
                        titleText="mep.amount.label"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={4}>
                    <CustomData
                        titleText="mep.concept.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`mep.reasons.${reasonCode}`}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={4}>
                    <CustomData titleText="mep.reference.label" titleTextType="I18N" valueText={reference} />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={5}>
                    <CustomData
                        titleText="mep.fee.label"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                currency={config.get("mep.fee.currency", "ARS")}
                                quantity={config.getInteger("mep.fee", 0)}
                            />
                        }
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

MepTransferSummaryBody.propTypes = {
    debitAccountId: string,
    creditCbu: string,
    transferKind: string,
    reasonCode: string,
    amount: shape({
        quantity: string,
        currency: string,
    }),
    reference: string,
    beneficiary: shape({}),
};

MepTransferSummaryBody.defaultProps = {
    debitAccountId: "",
    creditCbu: "",
    transferKind: "",
    reasonCode: "",
    amount: {
        quantity: "",
        currency: "",
    },
    reference: "",
    beneficiary: null,
};

export default MepTransferSummaryBody;
